import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Order from "@/pages/Order";
import OrderSuccess from "@/pages/OrderSuccess";
import TrackOrder from "@/pages/TrackOrder";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CustomerSignIn from "@/pages/CustomerSignIn";
import CustomerRegister from "@/pages/CustomerRegister";
import CustomerAccount from "@/pages/CustomerAccount";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

// Extracted so it's a stable reference across renders.
const TOASTER_OPTIONS = {
  style: {
    background: "#1A1514",
    color: "#F5F5F0",
    border: "1px solid rgba(255,255,255,0.08)",
  },
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/order" element={<Order />} />
            <Route path="/order/success/:orderNumber" element={<OrderSuccess />} />
            <Route path="/track" element={<TrackOrder />} />
            <Route path="/signin" element={<CustomerSignIn />} />
            <Route path="/register" element={<CustomerRegister />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/account" element={<CustomerAccount />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" toastOptions={TOASTER_OPTIONS} />
      </AuthProvider>
    </div>
  );
}

export default App;
